import Adminlogin from './pages/Adminlogin';
import EditOrg from './pages/EditOrg';
import EditPermission from './pages/EditPermission';
import OrgDashboard from '../organizationPages/OrgDashboard';
// import OrgSignIn from './pages/OrgSignIn';
import Permissions from './pages/Permissions';
import Roles from './pages/Roles';
import Unauthorized from './pages/Unauthorized';
import UserPermissions from './pages/UserPermissions';
import Transactions from './pages/Transactions';
import Cause from './pages/Cause';
import Causecategories from './pages/Causecategories';
import Addcause from './pages/Addcause';
import Addcausecategory from './pages/Addcausecategory';
import Organizations from './pages/Organizations';
import Addorganization from './pages/Addorganization';
import Useradd from './pages/Useradd';
import Useredit from './pages/Useredit';
import Editcause from './pages/Editcause';
import Editcausecategory from './pages/Editcausecategory';
// import Orgcause from '../organizationPages/Orgcause';
// import Addorgcause from '../organizationPages/Addorgcause';
// import Editorgcause from '../organizationPages/Editorgcause';
// import Orgevents from '../organizationPages/Orgevents';
// import Addorgevent from '../organizationPages/Addorgevent';
// import Editorgevent from '../organizationPages/Editorgevent';
// import Orgprayers from '../organizationPages/Orgprayers';
// import Addprayertime from '../organizationPages/Addprayertime';
// import Editprayertime from '../organizationPages/Editprayertime';
import Orgdonations from '../organizationPages/Orgdonations';
import Orguseredit from './pages/Orguseredit';
import Usersreport from './pages/Usersreport';
import Edituserpermissions from './pages/Edituserpermissions';
import Orgeventsreport from '../organizationPages/Orgeventsreport';
import Events from './pages/Events';
import Addevent from './pages/Addevent';
import Editevent from './pages/Editevent';
import Prayers from './pages/Prayers';
import Editprayer from './pages/Editprayer';
import Addprayer from './pages/Addprayer';
import City from './pages/City';
import States from './pages/State';
import Country from './pages/Country';
import AddCity from './pages/AddCity';
import EditCity from './pages/EditCity';
import AddState from './pages/AddState';
import EditState from './pages/EditState';
import AddCountry from './pages/AddCountry';
import EditCountry from './pages/EditCountry';
import Users from './pages/Users';
import Dashboard2 from './pages/Dashboard2';
import OrganizationsReport from './pages/OrganizationsReport';
import Kiosks from './pages/Kiosks';
import AddKiosk from './pages/AddKiosk';
import EditKiosk from './pages/EditKiosk';
import KioskReport from './pages/KioskReport';
import Profileedit from './pages/Profileedit';
// import OrgUsers from '../organizationPages/OrgUsers';
// import OrgUserAdd from '../organizationPages/OrgUserAdd';
// import OrgUserEdit from '../organizationPages/OrgUserEdit';
import OrgAds from './pages/OrgAds';
import AddOrgAd from './pages/AddOrgAd';
import EditOrgAd from './pages/EditOrgAd';
import AddAdminAds from './pages/AddAdminAds';
import AdminAds from './pages/AdminAds';
import EditAdminAd from './pages/EditAdminAd';
import Donor from './pages/Donor';
import DonationHistory from './pages/DonationHistory';
import RecurringDetails from './pages/RecurringDetails';
import Merchants from './pages/Merchants';
import AddMerchant from './pages/AddMerchant';
import EditMerchant from './pages/EditMerchant';
import RecurringDetailsRecord from './pages/RecurringDetailsRecord';
import OrganizationTypes from './pages/OrganizationTypes';
import AddOrgType from './pages/AddOrgType';
import EditOrgType from './pages/EditOrgType';
import Denominations from './pages/Denominations';
import AddDenomination from './pages/AddDenomination';
import EditDenomination from './pages/EditDenomination';
import RecurrCancelRequest from './pages/RecurrCancelRequest';
import DonorInfoReport from './pages/DonorInfoReport';
import PaymentList from './pages/PaymentList';
import AddPayment from './pages/AddPayment';
import EditPayment from './pages/EditPayment';

const allRoutes = [
  { id: 1, path: '/', component: <Adminlogin /> },
  // { id: 1, path: '/orgsignin', component: <OrgSignIn /> },
  { id: 2, path: 'dashboard/view', name: 'dashboard', component: <Dashboard2 /> },
  { id: 2, path: 'organization/dashboard', name: 'dashboard', component: <OrgDashboard /> },
  { id: 3, path: 'organizations/listall', name: 'orglist', component: <Organizations /> },
  { id: 4, path: 'user/getusers', name: 'users', component: <Users /> },
  { id: 6, path: 'user/add', name: 'adduser', component: <Useradd /> },
  { id: 7, path: 'user/edit', name: 'editUser', component: <Useredit /> },
  { id: 5, path: 'organization/add', name: 'AddOrg', component: <Addorganization /> },
  { id: 5, path: 'organization/editorg', name: 'editorg', component: <EditOrg /> },
  { id: 5, path: 'profile/editprofile', name: 'editorg', component: <EditOrg /> },
  { id: 4, path: 'orguser/view', name: 'users', component: <Users /> },
  { id: 6, path: 'orguser/add', name: 'adduser', component: <Useradd /> },
  { id: 7, path: 'orguser/edit', name: 'editUser', component: <Useredit /> },
  { id: 7, path: 'profile/edit', name: 'editProfile', component: <Profileedit /> },
  { id: 7, path: 'orguserprofile/edit', name: 'orgUserEdit', component: <Orguseredit /> },
  { id: 8, path: 'role/view', name: 'ViewRole', component: <Roles /> },
  { id: 9, path: 'role/edit', name: 'EditRole', component: <Edituserpermissions /> },
  { id: 9, path: 'permission/view', name: 'ViewPermissions', component: <Permissions /> },
  { id: 10, path: 'permission/edit', name: 'ViewPermissions', component: <EditPermission /> },
  { id: 11, path: 'userperm/view', name: 'ViewPermissions', component: <UserPermissions /> },
  { id: 15, path: 'userperm/edit', name: 'EditRolePermissions', component: <Edituserpermissions /> },
  { id: 15, path: 'paymentlink/view', name: 'ViewPaymentList', component:<PaymentList/>  },
  { id: 15, path: 'paymentlink/add', name: 'ViewPaymentList', component:<AddPayment/>  },
  { id: 15, path: 'paymentlink/edit', name: 'ViewPaymentList', component:<EditPayment/>  },
  { id: 12, path: 'transaction/view', name: 'ViewPermissions', component: <Transactions /> },
  { id: 13, path: 'cause/view', name: 'ViewCauses', component: <Cause /> },
  { id: 13, path: 'causes/view', name: 'ViewCauses', component: <Cause /> }, //Org Cause Page
  { id: 13, path: 'causes/add', name: 'AddOrgcauses', component: <Addcause /> },
  { id: 13, path: 'causes/edit', name: 'EditOrgcauses', component: <Editcause /> },
  { id: 13, path: 'event/view', name: 'ViewEvents', component: <Events /> },
  { id: 13, path: 'events/view', name: 'ViewEvents', component: <Events /> },
  { id: 13, path: 'event/add', name: 'AddOrgcauses', component: <Addevent /> }, 
  { id: 13, path: 'events/add', name: 'AddOrgcauses', component: <Addevent /> }, //Org Event Add
  { id: 13, path: 'event/edit', name: 'EditEvent', component: <Editevent /> },
  { id: 13, path: 'events/edit', name: 'EditOrgcauses', component: <Editevent /> }, //Org Event Update
  { id: 13, path: 'prayers/view', name: 'ViewEvents', component: <Prayers /> },
  { id: 13, path: 'prayer/view', name: 'ViewEvents', component: <Prayers /> },
  { id: 13, path: 'city/view', name: 'ViewCities', component: <City /> },
  { id: 13, path: 'city/add', name: 'AddCity', component: <AddCity /> },
  { id: 13, path: 'city/edit', name: 'AddCity', component: <EditCity /> },
  { id: 13, path: 'state/view', name: 'ViewCities', component: <States /> },
  { id: 13, path: 'state/add', name: 'AddState', component: <AddState /> },
  { id: 13, path: 'state/edit', name: 'EditState', component: <EditState /> },
  { id: 13, path: 'country/view', name: 'ViewCities', component: <Country /> },
  { id: 13, path: 'country/add', name: 'addCountry', component: <AddCountry /> },
  { id: 13, path: 'country/edit', name: 'editCountry', component: <EditCountry /> },
  { id: 13, path: 'prayers/add', name: 'AddOrgcauses', component: <Addprayer /> },
  { id: 13, path: 'prayer/add', name: 'AddOrgcauses', component: <Addprayer /> },
  { id: 13, path: 'prayers/edit', name: 'EditOrgcauses', component: <Editprayer /> },
  { id: 13, path: 'prayer/edit', name: 'EditOrgcauses', component: <Editprayer /> },
  { id: 13, path: 'donation/view', name: 'ViewEvents', component: <Orgdonations /> },
  { id: 14, path: 'cause/categories', name: 'ViewCauseCategories', component: <Causecategories /> },
  { id: 14, path: 'kiosk/view', name: 'ViewKiosks', component: <Kiosks /> },
  { id: 14, path: 'kiosk/add', name: 'AddKiosk', component: <AddKiosk /> },
  { id: 13, path: 'kiosk/edit', name: 'EditKiosk', component: <EditKiosk /> },
  { id: 15, path: 'cause/add', name: 'AddCause', component: <Addcause /> },
  { id: 15, path: 'cause/edit', name: 'EditCause', component: <Editcause /> },
  { id: 14, path: 'advertisement/view', name: 'ViewOrgAds', component: <OrgAds /> },
  { id: 14, path: 'advertisement/add', name: 'AddOrgAds', component: <AddOrgAd /> },
  { id: 14, path: 'advertisement/edit', name: 'EditOrgAds', component: <EditOrgAd /> },
  { id: 14, path: 'orgads/view', name: 'ViewOrgAds', component: <OrgAds /> },
  { id: 14, path: 'orgads/add', name: 'AddOrgAds', component: <AddOrgAd /> },
  { id: 14, path: 'orgads/edit', name: 'EditOrgAds', component: <EditOrgAd /> },
  { id: 14, path: 'adminads/view', name: 'ViewOrgAds', component: <AdminAds /> },
  { id: 14, path: 'adminads/add', name: 'AddOrgAds', component: <AddAdminAds /> },
  { id: 14, path: 'adminads/edit', name: 'EditOrgAds', component: <EditAdminAd /> },
  { id: 15, path: 'cause/add_category', name: 'ViewCauseCategories', component: <Addcausecategory /> },
  { id: 15, path: 'cause/editcategory', name: 'EditCauseCategory', component: <Editcausecategory /> },
  { id: 15, path: 'reports/users', name: 'Donation Report', component: <Usersreport /> },
  { id: 15, path: 'reports/organizations', name: 'Donation Report', component: <OrganizationsReport /> },
  { id: 15, path: 'reports/kiosk', name: 'Kiosk Report', component: <KioskReport /> },
  { id: 15, path: 'orgreport/donation', name: 'Donation Report', component: <DonationHistory /> },
  { id: 15, path: 'orgreport/donors', name: 'Donation Report', component: <Donor /> },
  { id: 15, path: 'orgreport/events', name: 'Donation Report', component: <Orgeventsreport /> },
  { id: 14, path: 'donor/view', name: 'ViewDonors', component: <Donor /> },
  { id: 14, path: 'donor/donationhistory', name: 'ViewDonationHistory', component: <DonationHistory /> },
  { id: 14, path: 'orgdonor/view', name: 'ViewDonors', component: <Donor /> },
  { id: 15, path: 'reports/donor', name: 'Donation Report', component: <Donor /> },
  { id: 15, path: 'reports/donation', name: 'Donation Report', component: <DonationHistory /> },
  { id: 14, path: 'orgdonor/donationhistory', name: 'ViewDonationHistory', component: <DonationHistory /> },
  { id: 14, path: 'recurring/bydoner', name: 'ViewDonorRecurring', component: <RecurringDetails /> },
  { id: 14, path: 'recurring/bydonerorg', name: 'ViewDonorRecurring', component: <RecurringDetails /> },
  { id: 15, path: 'orgreport/recurring', name: 'Donation Report', component: <RecurringDetails /> },
  { id: 15, path: 'reports/recurring', name: 'Admin Report', component: <RecurringDetails /> },
  { id: 15, path: 'reports/recurrdetails', name: 'Recurring Details', component: <RecurringDetailsRecord /> },
  { id: 15, path: 'reports/donorinfo', name: 'Recurring Details', component: <DonorInfoReport /> },
  { id: 14, path: 'merchant/view', name: 'View Merchants', component: <Merchants /> },
  { id: 14, path: 'merchant/add', name: 'Add Merchant', component: <AddMerchant /> },
  { id: 14, path: 'merchant/edit', name: 'Edit Merchant', component: <EditMerchant /> },
  { id: 14, path: 'organizations/types', name: 'View Organization Types', component: <OrganizationTypes /> },
  { id: 14, path: 'orgtype/add', name: 'Add Organization Type', component: <AddOrgType /> },
  { id: 14, path: 'orgtype/edit', name: 'Edit Organization Type', component: <EditOrgType /> },
  { id: 14, path: 'denominations/view', name: 'View Denominations', component: <Denominations /> },
  { id: 14, path: 'denomination/view', name: 'View Org Denominations', component: <Denominations /> },
  { id: 14, path: 'denominations/add', name: 'Add Organization Type', component: <AddDenomination /> },
  { id: 14, path: 'denominations/edit', name: 'Edit Organization Type', component: <EditDenomination /> },
  { id: 14, path: 'denomination/add', name: 'Add Organization Denomination', component: <AddDenomination /> },
  { id: 14, path: 'denomination/edit', name: 'Edit Organization Denomination', component: <EditDenomination /> },
  { id: 14, path: 'requests/view', name: 'View Recurr Cancel Request', component: <RecurrCancelRequest /> },
  { id: 16, path: '*', name: 'Loading', component: <Unauthorized /> },
];
export default allRoutes;

//   <DefaultAppRoutes>
// <Route path='/' element={<AdmnSignIn />} />
// <Route path='/orgsignin' element={<OrgSignIn />} />
// <Route path='/adminsignin' element={<AdmnSignIn />} />
// <Route path='*' element={<LoadingPage />} />
// </DefaultAppRoutes>
